// extracted by mini-css-extract-plugin
export default {"closeIcon":"DeleteIcon_closeIcon__M4rs8"};